const MAGICfile1 = {
  "name": "Play Fevir BMJ Rapid Recommendations: Sodium-Glucose Transport Protein 2 (SGLT2) inhibitors and Glucagon-Like Peptide-1 (GLP-1) receptor agonists for type 2 diabetes",
  "byName": "SGLT2 inhibitors and GLP-1 RA for type 2 diabetes",
  "shortCode": "LryW8j",
  "owner": "MAGIC Evidence Ecosystem Foundation",
  "mainEditor": "Per Olav Vandvik",
  "startDate": "2022-10-07T00:00:00",
  "lastEdit": "2022-10-07T13:02:39",
  "language": "en",
  "countryFlag": "uk",
  "sponsors": "",
  "disclaimer": "",
  "description": "",
  "isbn": "",
  "issn": "",
  "orgDocId": "",
  "contactName": "",
  "contactAddress": "",
  "contactEmail": "",
  "contactTelephone": "",
  "contactWeb": "",
  "institutionId": 87,
  "institutionName": "MAGIC Evidence Ecosystem Foundation",
  "institutionLogoUrl": "https://files.magicapp.org/static/images/orgs/org_87.png",
  "institutionAltGrade": false,
  "guidelineId": 6704,
  "currentDraftId": 6704,
  "permission": 1,
  "isLatestPublished": false,
  "isDraftEditable": false,
  "isPublic": false,
  "versionMajor": 0,
  "versionMinor": 0,
  "draftPicoCount": 0,
  "draftRecommendationCount": 0,
  "publishedPicoCount": 0,
  "publishedRecommendationCount": 0,
  "contentAdmin": false,
  "status": "NOTSET",
  "commentsInPublished": true,
  "trackChanges": false,
  "sectionNumbers": true,
  "showRecByline": true,
  "showConflicts": true,
  "showCertaintyStrengthLabels": false,
  "showSectionPreview": false,
  "defaultKeyInfoType": "SUMMARY",
  "sections": [{
    "sectionId": 116147,
    "parentId": 116145,
    "order": 2,
    "shortCode": "LwrXGd",
    "sectionLabel": "4.2",
    "heading": "Adults with 3  more risk factors and no underlying CVD or CKD",
    "text": "",
    "hasChildren": false,
    "counts": {
      "picoCount": 2,
      "recommendationCount": 2
    },
    "hasUncommittedChanges": false,
    "guidelineId": 6704,
    "subSections": [],
    "picos": [],
    "recommendations": [{
      "recommendationId": 133584,
      "shortCode": "jMp7RR",
      "guidelineId": 6704,
      "sectionId": 116147,
      "order": 1,
      "strength": "WEAK",
      "status": "NOTSET",
      "statusDate": null,
      "statusComment": null,
      "heading": "",
      "text": "We suggest starting SGLT-2 inhibitors.",
      "remarks": "<ul><li>Risk scores and calculators such as RECODe may assist in identifying your patient:&nbsp;<a href=\"https://sanjaybasu.shinyapps.io/recode/\">https://sanjaybasu.shinyapps.io/recode/</a></li><li>The MATCH-IT decision support tool allows you to interact with the evidence and your patients across the alternative options:&nbsp;<a href=\"http://magicproject.org/200521dist/\">http://magicproject.org/200521dist/</a></li></ul>\n",
      "advice": "<strong>Medication Routine</strong><br>\n&nbsp;<br>\nThe common form of the GLP-1 receptor agonists involves one (eg. liraglutide and lixisenatide) or two (eg. exenatide) daily subcutaneous injections; new preparations require only weekly injections (eg. albiglutide, dulaglutide, exenatide synthetic, and semaglutide). Oral semaglutide tablet is now approved by the United States Food and Drug Administration (FDA) and Health Canada, but not widely accessible in other countries.&nbsp; A compound preparation of GLP-1 receptor agonists and insulin is available and may not require increasing the frequency of injection. &nbsp;Our recommendation regarding GLP-1 receptor agonists is mainly based on the once-daily preparation.<br>\n&nbsp;<br>\nSGLT-2 inhibitors are oral medicines.<br>\n&nbsp;<br>\nMost anti-diabetic medications sould not be taken while a person is sick, especially if there is vomiting, diarrhoea, or the person isn’t eating and drinking very much. Most anti-diabetic medications are tablets except insulin, an injection. Insulin can be used while a person is sick and needs glucose-lowering medication.<br>\n&nbsp;<br>\n<strong>Test and visit</strong><br>\n&nbsp;<br>\nRegular blood samples, and more frequently after starting a new medication. We only consider adding these medications when the patient has HbA1C above 6.5.<br>\n&nbsp;<br>\nSGLT-2 inhibitors: needs to monitor blood pressure and kidney function.<br>\n&nbsp;<br>\nUsual care: needs self-monitoring of blood glucose at home if the patients are receiving insulin, sulfonylureas, or meglitinides.<br>\n&nbsp;<br>\n<strong>Recovery and adaptation</strong><br>\n&nbsp;<br>\nMost people need to take diabetes medications for the rest of their lives.<br>\n&nbsp;<br>\n<strong>Adverse effects, interactions, and antidote</strong><br>\n&nbsp;<br>\nSGLT-2 inhibitors or GLP-1 RAs do not increase the risk of hypoglycaemia when taken alone. But they do increase the risk of hypoglycaemia increase when used in combination with some medications such as insulin or insulin secretagogues.<br>\n&nbsp;<br>\nSGLT-2 inhibitors<br>\nMild to moderate genital infections can occur. Low blood pressure, dizziness, dehydration, etc., especially among people older than 65 years or when combined with diuretics. All patients should monitor for signs of diabetic ketoacidosis (even if the blood glucose is within the normal range) and seek hospital attention immediately if it occurs.<br>\n&nbsp;<br>\nGLP-1 RAs<br>\nDose-dependent gastrointestinal adverse reactions, including nausea, vomiting, diarrhoea, abdominal pain, indigestion, decreased appetite. These effects are usually most pronounced in the first few weeks after beginning medication and should be put to special caution in. patients with inflammatory bowel diseases or diabetic gastroparesis. Acute pancreatitis is a rare but serious adverse effect that can occur. GLP-RAs should not be used in combination with DPP-4 inhibitors.<br>\n&nbsp;<br>\nOther anti-diabetic medications<br>\n&nbsp;<br>\nAdverse effects vary between specific agents, especially for insulin or insulin secretagogues can cause low blood sugar.<br>\n&nbsp;<br>\n<strong>Physical well-being</strong><br>\n&nbsp;<br>\nBoth SGLT-2 inhibitors and GLP-1 RAs have a weight loss effect.<br>\n&nbsp;<br>\nWeight gain: sulfonylurea, thiazolidinediones, meglitinides, and insulin.<br>\n&nbsp;<br>\n<strong>Pregnancy and nursing</strong><br>\n&nbsp;<br>\nBoth SGLT-2 inhibitors and GLP-1 RAs should be avoided during pregnancy and nursing, or in women who may become pregnant.<br>\n&nbsp;<br>\nLifestyle intervention and human insulin can be considered during pregnancy and nursing. Glibenclamide, metformin, and insulin analogues can be considered in some countries such as the US.<br>\n&nbsp;<br>\n<strong>Costs and access</strong><br>\n&nbsp;<br>\nCosts vary between specific agents and depend on health insurance and policy. GLP-1 RAs are usually 2 to 3 times more expensive than SGLT-2 inhibitors.<br>\n&nbsp;<br>\nMetformin and sulfonylureas are usually inexpensive and easy to access.<br>\n&nbsp;<br>\n<strong>Food and drinks</strong><br>\n&nbsp;<br>\nDrinking more water may be helpful for patients receiving SGLT-2 inhibitors and prevent thirstily and dehydration. Dietary control is advised to control body weight.<br>\n&nbsp;<br>\n<strong>Storage and transportation before use</strong><br>\n&nbsp;<br>\nGLP-1 RAs and insulin should be stored and transported between 2℃ to 8℃ before the first use.<br>\n&nbsp;<br>\n<strong>Exercise and activities</strong><br>\n&nbsp;<br>\nModerate exercise and activities are advised.<br>\n&nbsp;<br>\n<strong>Travel time and driving</strong><br>\n&nbsp;<br>\nPatients at risk for undetected symptomatic hypoglycaemia need to be aware of the risk of driving. Patients using GLP-1 receptor agonists and insulin may need a special package to bring their medications and their injection equipment when travelling. The medications should be stored below 30℃ (25℃ for exenatide and benaglutide) avoiding sunshine and freezing after the first use.<br>\n&nbsp;<br>\n<strong>Baseline kidney function</strong><br>\n&nbsp;<br>\nThe FDA label suggests that empagliflozin should not be used in patients with eGFR below 45 mL/min/1.73 m2, and canagliflozin, ertugliflozin, and dapagliflozin should not be used in patients with eGFR below 30 mL/min/1.73 m2. All SGLT-2 inhibitors are contraindicated in patients with kidney failure or dialysis.<br>\n&nbsp;",
      "rational": "Recommendations considered the evidence to decision domains including the balance of benefits, harms, and burdens of SGLT-2 inhibitors and GLP-1 receptor agonists, the certainty of the evidence, typical and expected variations in patients’ values and preferences, feasibility, acceptability and equity issues.",
      "adaptation": "",
      "implementation": "",
      "evaluation": "",
      "research": "",
      "keyInfoType": "SUMMARY",
      "keyInfoDisplayMode": "TEXT",
      "showAdaptation": false,
      "hideInPublish": false,
      "tags": null,
      "keyInfo": {
        "keyInfoType": "SUMMARY",
        "recommendationId": 133584,
        "guidelineId": null,
        "benefits": "The panel found that SGLT2 inhibitors reduce the risk of all cause death, nonfatal myocardial infarction and hospital admission for heart failure for this group; SGLT2 inhibitors have little or no impact on nonfatal stroke, end-stage kidney disease for this group.&nbsp;SGLT2 inhibitors increase the risk of genital infection.&nbsp;",
        "benefitsResearchEvidence": "",
        "benefitsResearchEvidenceInPublic": false,
        "benefitsAdditionalConsideration": "",
        "benefitsAdditionalConsiderationInPublic": false,
        "evidence": "The certainty for all-cause death, non-fatal myocardial infarction, non-fatal stroke, end-stage kidney disease, hospital admission for heart failure, diabetic ketoacidosis, genital infections is moderate to high. The certainty for health-related quality of life, bodyweight&nbsp;is low.",
        "evidenceResearchEvidence": "",
        "evidenceResearchEvidenceInPublic": false,
        "evidenceAdditionalConsideration": "",
        "evidenceAdditionalConsiderationInPublic": false,
        "preferences": "People with diabetes preferred oral medication over injectable treatment, once-weekly injections over once-daily injections and simplicity in injection devices.<br>\n<br>\nOf the seven participants in the focus group study, two were willing to accept very small benefits to use either medication (less than 5 in 1000 patients risk reduction in five years), while two would decline either medication even given the largest possible benefit (more than 30 in 1000 patients risk reduction in five years).&nbsp; Participants weighed avoiding kidney failure similarly to avoiding death, and more highly than avoiding myocardial infarction, stroke, and hospitalization due to heart failure. &nbsp;Similar to the systematic review of values and preferences, the focus group participants strongly preferred oral medications over injectables.&nbsp;<br>\n&nbsp;",
        "preferencesResearchEvidence": "",
        "preferencesResearchEvidenceInPublic": false,
        "preferencesAdditionalConsideration": "",
        "preferencesAdditionalConsiderationInPublic": false,
        "resources": "SGLT-2 inhibitors have been widely used in the US, Canada, Europe, and China.&nbsp; However, they are unavailable in many other countries.&nbsp;&nbsp;<br>\n&nbsp;<br>\nSGLT-2 inhibitors are still expensive in some countries, and not fully covered or covered under certain conditions by insurance.&nbsp;The cost-effectiveness of the medications was not considered in the current guideline, due to variation in access and models of health care reimbursement internationally.<br>\n&nbsp;<br>\nSGLT-2 inhibitors are oral medicines.&nbsp;Most anti-diabetic medications are tablets except insulin, an injection. Insulin can be used while a person is sick and needs glucose-lowering medication.<br>\n&nbsp;",
        "resourcesResearchEvidence": "",
        "resourcesResearchEvidenceInPublic": false,
        "resourcesAdditionalConsideration": "",
        "resourcesAdditionalConsiderationInPublic": false,
        "benefitsStrength": "NOTSET",
        "evidenceStrength": "NOTSET",
        "preferencesStrength": "NOTSET",
        "resourcesStrength": "NOTSET",
        "interventions": [{
          "recommendationId": 133584,
          "picoId": 113494,
          "picoElement": "I",
          "intervention": "Sodium-Glucose Transport Protein 2 (SGLT2) inhibitors",
          "isComparator": false,
          "showComparator": true,
          "sortOrder": 9999,
          "judgements": {
            "BENEFITS_DESIRABLE": "NOT_SET",
            "BENEFITS_UNDESIRABLE": "NOT_SET",
            "EVIDENCE": "NOT_SET",
            "PREFERENCES": "NOT_SET",
            "RESOURCES": "NOT_SET"
          },
          "comparator": false
        }, {
          "recommendationId": 133584,
          "picoId": 113494,
          "picoElement": "C",
          "intervention": "Standard care",
          "isComparator": false,
          "showComparator": true,
          "sortOrder": 9999,
          "judgements": {
            "BENEFITS_DESIRABLE": "NOT_SET",
            "BENEFITS_UNDESIRABLE": "NOT_SET",
            "EVIDENCE": "NOT_SET",
            "PREFERENCES": "NOT_SET",
            "RESOURCES": "NOT_SET"
          },
          "comparator": false
        }],
        "isSummaryOfJudgementPublic": false
      },
      "interventions": {
        "recommendationId": 133584,
        "shortCode": "jMp7RR",
        "guidelineId": 6704,
        "sectionId": 116147,
        "emrImplement": "",
        "emrResources": "",
        "targetPopulation": "",
        "recommendedInvention": "",
        "codes": []
      },
      "emrCodes": [],
      "referenceId": [507287, 507288],
      "picoId": [113494],
      "picos": [{
        "picoId": 113494,
        "sectionId": 116147,
        "order": 1,
        "population": "Adults with type 2 diabetes plus 3 more risk factors and no underlying CVD or CKD",
        "populationShortName": "Adults with type 2 diabetes with low CV risk",
        "intervention": "Sodium-Glucose Transport Protein 2 (SGLT2) inhibitors",
        "interventionShortName": "SGLT2 inhibitors",
        "comparator": "Standard care",
        "comparatorShortName": "Standard care",
        "shortCode": "jOpBlN",
        "summary": "",
        "outcomes": {
          "picoId": 113494,
          "sectionId": 116147,
          "dichotomousOutcomes": [{
            "outcomeId": 451198,
            "picoId": 113494,
            "sectionId": 116147,
            "status": "DEVELOPMENT",
            "isHidden": false,
            "autoCalc": true,
            "sortOrder": 10,
            "shortCode": "LqgGk4",
            "outcome": "All-cause mortality",
            "shortName": "All-cause mortality",
            "importanceLevel": "NOTSET",
            "interventionStudies": "225",
            "interventionTotalParticipants": 282704.0,
            "interventionReferenceType": "SYSTEMATIC_REVIEW",
            "interventionStudyType": "RANDOMISED_CONTROLLED_TRIALS",
            "comparatorStudyType": "NOTSET",
            "comparatorReferenceType": "COMPARATOR_ARM",
            "comparatorComment": "From RECODe to an estimate per 1000 patients for 5 years (https://sanjaybasu.shinyapps.io/recode/)",
            "qualityInterventionStudyType": "RANDOMISED_CONTROLLED_TRIALS",
            "qualityOfEvidenceLevel": "MODERATE",
            "qualityOfEvidenceComment": "Due to serious imprecision",
            "qualityRiskOfBias": "NOTSET",
            "qualityInconsistency": "NOTSET",
            "qualityIndirectness": "NOTSET",
            "qualityImprecision": "SERIOUS",
            "qualityPublicationBias": "NOTSET",
            "qualityUpgrade": "NOTSET",
            "plainSummaryComment": "SGLT2 inhibitors reduce the risk of death compared with standard care.",
            "directionOfEffectType": "NOT_SET",
            "absoluteDifference": 10.0,
            "absoluteDifferenceDirection": "FEW",
            "absoluteDifferenceConfidenceType": "CI95",
            "absoluteDifferenceLow": 14.0,
            "absoluteDifferenceLowDirection": "FEW",
            "absoluteDifferenceHigh": 5.0,
            "absoluteDifferenceHighDirection": "FEW",
            "relativeEffect": 0.85,
            "relativeEffectType": "OR",
            "relativeEffectConfidenceType": "CI95",
            "relativeEffectConfidenceLow": 0.79,
            "relativeEffectConfidenceHigh": 0.92,
            "comparatorEffect": 70.0,
            "comparatorEffectType": "PER_THOUSAND",
            "interventionEffect": 60.0,
            "interventionEffectType": "PER_THOUSAND",
            "autoCalcInterventions": "MANUAL"
          }, {
            "outcomeId": 451199,
            "picoId": 113494,
            "sectionId": 116147,
            "status": "DEVELOPMENT",
            "isHidden": false,
            "autoCalc": true,
            "sortOrder": 20,
            "shortCode": "EZVv5k",
            "outcome": "Cardiovascular mortality",
            "shortName": "Cardiovascular mortality",
            "importanceLevel": "NOTSET",
            "interventionStudies": "128",
            "interventionTotalParticipants": 222944.0,
            "interventionReferenceType": "SYSTEMATIC_REVIEW",
            "interventionStudyType": "RANDOMISED_CONTROLLED_TRIALS",
            "comparatorStudyType": "NOTSET",
            "comparatorReferenceType": "NO_STUDY",
            "comparatorComment": "From RECODe to an estimate per 1000 patients for 5 years with the following assumption: CV mortality is 2/3 of all-cause mortality (https://sanjaybasu.shinyapps.io/recode/).",
            "qualityInterventionStudyType": "RANDOMISED_CONTROLLED_TRIALS",
            "qualityOfEvidenceLevel": "MODERATE",
            "qualityOfEvidenceComment": "Due to serious imprecision.",
            "qualityRiskOfBias": "NOTSET",
            "qualityInconsistency": "SERIOUS",
            "qualityIndirectness": "NOTSET",
            "qualityImprecision": "NOTSET",
            "qualityPublicationBias": "NOTSET",
            "qualityUpgrade": "NOTSET",
            "plainSummaryComment": "SGLT2 inhibitors probably reduce the risk of cardiovascular death compared with standard care.",
            "directionOfEffectType": "NOT_SET",
            "absoluteDifference": 7.0,
            "absoluteDifferenceDirection": "FEW",
            "absoluteDifferenceConfidenceType": "CI95",
            "absoluteDifferenceLow": 11.0,
            "absoluteDifferenceLowDirection": "FEW",
            "absoluteDifferenceHigh": 4.0,
            "absoluteDifferenceHighDirection": "FEW",
            "relativeEffect": 0.84,
            "relativeEffectType": "OR",
            "relativeEffectConfidenceType": "CI95",
            "relativeEffectConfidenceLow": 0.76,
            "relativeEffectConfidenceHigh": 0.92,
            "comparatorEffect": 46.0,
            "comparatorEffectType": "PER_THOUSAND",
            "interventionEffect": 39.0,
            "interventionEffectType": "PER_THOUSAND",
            "autoCalcInterventions": "MANUAL"
          }, {
            "outcomeId": 451200,
            "picoId": 113494,
            "sectionId": 116147,
            "status": "DEVELOPMENT",
            "isHidden": false,
            "autoCalc": true,
            "sortOrder": 30,
            "shortCode": "EQ3olD",
            "outcome": "Nonfatal myocardial infarction",
            "shortName": "Nonfatal myocardial infarction",
            "interventionStudies": "199",
            "interventionTotalParticipants": 262168.0,
            "interventionReferenceType": "SYSTEMATIC_REVIEW",
            "interventionStudyType": "RANDOMISED_CONTROLLED_TRIALS",
            "comparatorStudyType": "NOTSET",
            "comparatorReferenceType": "NO_STUDY",
            "comparatorComment": "From RECODe to an estimate per 1000 patients for 5 years with the following assumption: Non-fatal MI and non-fatal stroke are equally distribute (https://sanjaybasu.shinyapps.io/recode/).",
            "qualityInterventionStudyType": "RANDOMISED_CONTROLLED_TRIALS",
            "qualityOfEvidenceLevel": "MODERATE",
            "qualityOfEvidenceComment": "Due to serious imprecision",
            "qualityRiskOfBias": "NOTSET",
            "qualityInconsistency": "NOTSET",
            "qualityIndirectness": "NOTSET",
            "qualityImprecision": "NOTSET",
            "qualityPublicationBias": "NOTSET",
            "qualityUpgrade": "NOTSET",
            "plainSummaryComment": "SGLT2 inhibitors probably reduce the risk of nonfatal myocardial infarction compared with standard care.",
            "directionOfEffectType": "NOT_SET",
            "absoluteDifference": 7.0,
            "absoluteDifferenceDirection": "FEW",
            "absoluteDifferenceConfidenceType": "CI95",
            "absoluteDifferenceLow": 12.0,
            "absoluteDifferenceLowDirection": "FEW",
            "absoluteDifferenceHigh": 2.0,
            "absoluteDifferenceHighDirection": "FEW",
            "relativeEffect": 0.87,
            "relativeEffectType": "OR",
            "relativeEffectConfidenceType": "CI95",
            "relativeEffectConfidenceLow": 0.79,
            "relativeEffectConfidenceHigh": 0.97,
            "comparatorEffect": 58.0,
            "comparatorEffectType": "PER_THOUSAND",
            "interventionEffect": 51.0,
            "interventionEffectType": "PER_THOUSAND",
            "autoCalcInterventions": "MANUAL"
          }, {
            "outcomeId": 451201,
            "picoId": 113494,
            "sectionId": 116147,
            "status": "DEVELOPMENT",
            "isHidden": false,
            "autoCalc": true,
            "sortOrder": 40,
            "shortCode": "jMK9GR",
            "outcome": "Nonfatal stroke",
            "shortName": "Nonfatal stroke",
            "interventionStudies": "171",
            "interventionTotalParticipants": 257767.0,
            "interventionReferenceType": "SYSTEMATIC_REVIEW",
            "interventionStudyType": "RANDOMISED_CONTROLLED_TRIALS",
            "comparatorStudyType": "NOTSET",
            "comparatorReferenceType": "NO_STUDY",
            "comparatorComment": "From RECODe to an estimate per 1000 patients for 5 years with the following assumption: Non-fatal MI and non-fatal stroke are equally distribute (https://sanjaybasu.shinyapps.io/recode/).",
            "qualityInterventionStudyType": "RANDOMISED_CONTROLLED_TRIALS",
            "qualityOfEvidenceLevel": "HIGH",
            "qualityRiskOfBias": "NOTSET",
            "qualityInconsistency": "NOTSET",
            "qualityIndirectness": "NOTSET",
            "qualityImprecision": "NOTSET",
            "qualityPublicationBias": "NOTSET",
            "qualityUpgrade": "NOTSET",
            "plainSummaryComment": " SGLT2 inhibitors have little or no impact on nonfatal stroke.",
            "directionOfEffectType": "NOT_SET",
            "absoluteDifference": 1.0,
            "absoluteDifferenceDirection": "MORE",
            "absoluteDifferenceConfidenceType": "CI95",
            "absoluteDifferenceLow": 6.0,
            "absoluteDifferenceLowDirection": "FEW",
            "absoluteDifferenceHigh": 8.0,
            "absoluteDifferenceHighDirection": "MORE",
            "relativeEffect": 1.01,
            "relativeEffectType": "OR",
            "relativeEffectConfidenceType": "CI95",
            "relativeEffectConfidenceLow": 0.89,
            "relativeEffectConfidenceHigh": 1.14,
            "comparatorEffect": 58.0,
            "comparatorEffectType": "PER_THOUSAND",
            "interventionEffect": 59.0,
            "interventionEffectType": "PER_THOUSAND",
            "autoCalcInterventions": "MANUAL"
          }, {
            "outcomeId": 451202,
            "picoId": 113494,
            "sectionId": 116147,
            "status": "DEVELOPMENT",
            "isHidden": false,
            "autoCalc": true,
            "sortOrder": 50,
            "shortCode": "EKOK5e",
            "outcome": "End-stage kidney disease",
            "shortName": "End-stage kidney disease",
            "interventionStudies": "31",
            "interventionTotalParticipants": 79896.0,
            "interventionReferenceType": "SYSTEMATIC_REVIEW",
            "interventionStudyType": "NOTSET",
            "comparatorStudyType": "NOTSET",
            "comparatorReferenceType": "PRIMARY_STUDY",
            "comparatorComment": "Defined as a GFR below 45 or a GFR below 70 AND macroalbuminuria (ACR > 200 mg/g); from the New Zealand Society for the Study of Diabetes. https://www.nzssd.org.nz/cvd_renal/",
            "qualityInterventionStudyType": "NOTSET",
            "qualityOfEvidenceLevel": "HIGH",
            "qualityRiskOfBias": "NOTSET",
            "qualityInconsistency": "NOTSET",
            "qualityIndirectness": "NOTSET",
            "qualityImprecision": "NOTSET",
            "qualityPublicationBias": "NOTSET",
            "qualityUpgrade": "NOTSET",
            "plainSummaryComment": "There is no important difference between SGLT2 inhibitors and standard care.\n",
            "directionOfEffectType": "NOT_SET",
            "absoluteDifference": 3.0,
            "absoluteDifferenceDirection": "FEW",
            "absoluteDifferenceConfidenceType": "CI95",
            "absoluteDifferenceLow": 4.0,
            "absoluteDifferenceLowDirection": "FEW",
            "absoluteDifferenceHigh": 1.0,
            "absoluteDifferenceHighDirection": "FEW",
            "relativeEffect": 0.71,
            "relativeEffectType": "OR",
            "relativeEffectConfidenceType": "CI95",
            "relativeEffectConfidenceLow": 0.57,
            "relativeEffectConfidenceHigh": 0.89,
            "comparatorEffect": 10.0,
            "comparatorEffectType": "PER_THOUSAND",
            "interventionEffect": 7.0,
            "interventionEffectType": "PER_THOUSAND",
            "autoCalcInterventions": "MANUAL"
          }, {
            "outcomeId": 451203,
            "picoId": 113494,
            "sectionId": 116147,
            "status": "DEVELOPMENT",
            "isHidden": false,
            "autoCalc": true,
            "sortOrder": 60,
            "shortCode": "jW0ND9",
            "outcome": "Heart failure",
            "shortName": "Hospital admission for heart failure",
            "importanceLevel": "NOTSET",
            "interventionStudies": "141",
            "interventionTotalParticipants": 229615.0,
            "interventionReferenceType": "SYSTEMATIC_REVIEW",
            "interventionStudyType": "RANDOMISED_CONTROLLED_TRIALS",
            "comparatorStudyType": "NOTSET",
            "comparatorReferenceType": "COMPARATOR_ARM",
            "comparatorComment": "Data from the placebo arm in included trials (median).",
            "qualityInterventionStudyType": "RANDOMISED_CONTROLLED_TRIALS",
            "qualityOfEvidenceLevel": "MODERATE",
            "qualityOfEvidenceComment": "Due to serious imprecision",
            "qualityRiskOfBias": "NOTSET",
            "qualityInconsistency": "NOTSET",
            "qualityIndirectness": "NOTSET",
            "qualityImprecision": "NOTSET",
            "qualityPublicationBias": "NOTSET",
            "qualityUpgrade": "NOTSET",
            "plainSummaryComment": "SGLT2 inhibitors reduce the risk of heart failure compared with standard care.",
            "directionOfEffectType": "NOT_SET",
            "absoluteDifference": 9.0,
            "absoluteDifferenceDirection": "FEW",
            "absoluteDifferenceConfidenceType": "CI95",
            "absoluteDifferenceLow": 11.0,
            "absoluteDifferenceLowDirection": "FEW",
            "absoluteDifferenceHigh": 7.0,
            "absoluteDifferenceHighDirection": "FEW",
            "relativeEffect": 0.7,
            "relativeEffectType": "OR",
            "relativeEffectConfidenceType": "CI95",
            "relativeEffectConfidenceLow": 0.63,
            "relativeEffectConfidenceHigh": 0.77,
            "comparatorEffect": 30.0,
            "comparatorEffectType": "PER_THOUSAND",
            "interventionEffect": 21.0,
            "interventionEffectType": "PER_THOUSAND",
            "autoCalcInterventions": "MANUAL"
          }, {
            "outcomeId": 451204,
            "picoId": 113494,
            "sectionId": 116147,
            "status": "DEVELOPMENT",
            "isHidden": false,
            "autoCalc": true,
            "sortOrder": 70,
            "shortCode": "E5W5NW",
            "outcome": "Diabetic ketoacidosis",
            "shortName": "Diabetic ketoacidosis",
            "importanceLevel": "NOTSET",
            "interventionStudies": "26",
            "interventionTotalParticipants": 98634.0,
            "interventionReferenceType": "SYSTEMATIC_REVIEW",
            "interventionStudyType": "NOTSET",
            "comparatorStudyType": "NOTSET",
            "comparatorReferenceType": "COMPARATOR_ARM",
            "comparatorComment": "Data from the placebo arm in included trials (median).",
            "qualityInterventionStudyType": "NOTSET",
            "qualityOfEvidenceLevel": "HIGH",
            "qualityRiskOfBias": "NOTSET",
            "qualityInconsistency": "NOTSET",
            "qualityIndirectness": "NOTSET",
            "qualityImprecision": "NOTSET",
            "qualityPublicationBias": "NOTSET",
            "qualityUpgrade": "NOTSET",
            "plainSummaryComment": "There is no important difference between SGLT2 inhibitors and standard care.",
            "directionOfEffectType": "NOT_SET",
            "absoluteDifference": 0.0,
            "absoluteDifferenceDirection": "FEW",
            "absoluteDifferenceConfidenceType": "CI95",
            "absoluteDifferenceLow": 1.0,
            "absoluteDifferenceLowDirection": "FEW",
            "absoluteDifferenceHigh": 2.0,
            "absoluteDifferenceHighDirection": "MORE",
            "relativeEffect": 1.04,
            "relativeEffectType": "OR",
            "relativeEffectConfidenceType": "CI95",
            "relativeEffectConfidenceLow": 0.61,
            "relativeEffectConfidenceHigh": 1.78,
            "comparatorEffect": 2.0,
            "comparatorEffectType": "PER_THOUSAND",
            "interventionEffect": 2.0,
            "interventionEffectType": "PER_THOUSAND",
            "autoCalcInterventions": "MANUAL"
          }, {
            "outcomeId": 451205,
            "picoId": 113494,
            "sectionId": 116147,
            "status": "DEVELOPMENT",
            "isHidden": false,
            "autoCalc": true,
            "sortOrder": 80,
            "shortCode": "j1QkNk",
            "outcome": "Genital infection",
            "shortName": "Genital infection",
            "interventionStudies": "78",
            "interventionTotalParticipants": 80771.0,
            "interventionReferenceType": "SYSTEMATIC_REVIEW",
            "interventionStudyType": "RANDOMISED_CONTROLLED_TRIALS",
            "comparatorStudyType": "NOTSET",
            "comparatorReferenceType": "PRIMARY_STUDY",
            "qualityInterventionStudyType": "RANDOMISED_CONTROLLED_TRIALS",
            "qualityOfEvidenceLevel": "HIGH",
            "qualityRiskOfBias": "NOTSET",
            "qualityInconsistency": "NOTSET",
            "qualityIndirectness": "NOTSET",
            "qualityImprecision": "NOTSET",
            "qualityPublicationBias": "NOTSET",
            "qualityUpgrade": "NOTSET",
            "plainSummaryComment": "SGLT2 inhibitors increase the risk of genital infection compared with standard care.",
            "directionOfEffectType": "NOT_SET",
            "absoluteDifference": 143.0,
            "absoluteDifferenceDirection": "MORE",
            "absoluteDifferenceConfidenceType": "CI95",
            "absoluteDifferenceLow": 119.0,
            "absoluteDifferenceLowDirection": "MORE",
            "absoluteDifferenceHigh": 170.0,
            "absoluteDifferenceHighDirection": "MORE",
            "relativeEffect": 3.5,
            "relativeEffectType": "OR",
            "relativeEffectConfidenceType": "CI95",
            "relativeEffectConfidenceLow": 3.01,
            "relativeEffectConfidenceHigh": 4.07,
            "comparatorEffect": 73.0,
            "comparatorEffectType": "PER_THOUSAND",
            "interventionEffect": 216.0,
            "interventionEffectType": "PER_THOUSAND",
            "comparatorStudyData": [{
              "referenceStudyDataId": null,
              "outcomeId": 451205,
              "referenceId": 507288,
              "studyDataId": 499242,
              "revManStudyDataId": null,
              "autoAdd": false,
              "study": "Hirji",
              "studyType": "",
              "followUp": "",
              "totalParticipants": null,
              "interventionParticipants": null,
              "comparatorParticipants": null,
              "weight": 0.0,
              "reference": {
                "referenceId": 507288,
                "referenceNumber": 4,
                "authors": [{
                  "id": 3541442,
                  "firstName": "Ishan",
                  "lastName": "Hirji",
                  "formattedName": "Hirji I"
                }, {
                  "id": 3541443,
                  "firstName": "Susan W",
                  "lastName": "Andersson",
                  "formattedName": "Andersson SW"
                }, {
                  "id": 3541444,
                  "firstName": "Zhenchao",
                  "lastName": "Guo",
                  "formattedName": "Guo Z"
                }, {
                  "id": 3541445,
                  "firstName": "Niklas",
                  "lastName": "Hammar",
                  "formattedName": "Hammar N"
                }, {
                  "id": 3541446,
                  "firstName": "Andres",
                  "lastName": "Gomez-Caminero",
                  "formattedName": "Gomez-Caminero A"
                }],
                "titleText": "Incidence of genital infection among patients with type 2 diabetes in the UK General Practice Research Database.",
                "url": "",
                "doi": "10.1016/j.jdiacomp.2012.06.012",
                "pmid": "22840886",
                "journal": "Journal of diabetes and its complications",
                "year": "",
                "volume": "26",
                "issue": "6",
                "pageStart": "501-5",
                "pageEnd": "",
                "creationType": "PUBMED",
                "guidelineId": 6704,
                "evidenceSummaryId": null,
                "shortName": "Hirji",
                "order": 4,
                "referenceType": "PRIMARY_STUDY",
                "studyType": "NOT_SET",
                "attachedFiles": [],
                "abstractText": "The objective of this population-based study was to evaluate the incidence of vaginitis (females) and balanitis (males) among a cohort of type 2 diabetes patients and compare this risk to patients without diabetes. The study population included 125,237 female patients and 146,603 males identified from GPRD. All patients were followed for 1-year from their study index date for the first record of an infection or a censored event. Among patients with diabetes the incidence of vaginitis was 21.0/1000PY (95% CI 19.8-22.1) with the risk being 1.81 (95% CI 1.64-2.00) greater that patients without diabetes. The incidence of balanitis among diabetes patients was 8.4/1000PY (95% CI 7.8-9.1) with a relative risk of 2.85 (2.39-3.39) compared to patients without diabetes. Additional analyses were performed by HbA1c level. Results from this large population-based study indicate that patients with diabetes are at an increased risk of being diagnosed with infections of the genital tract and patients with poorly controlled diabetes have higher risks.\n",
                "comments": "",
                "selected": false,
                "usageCount": null,
                "files": [],
                "results": ""
              },
              "interventionEvents": null,
              "comparatorEvents": null,
              "relativeEffectType": "OR",
              "relativeEffect": null,
              "relativeEffectConfidenceLow": null,
              "relativeEffectConfidenceHigh": null,
              "referenceNumber": 4
            }],
            "autoCalcInterventions": "MANUAL"
          }],
          "continuousOutcomes": [{
            "outcomeId": 136749,
            "picoId": 113494,
            "sectionId": 116147,
            "status": "DEVELOPMENT",
            "isHidden": false,
            "autoCalc": true,
            "sortOrder": 10,
            "shortCode": "nBMRq8",
            "outcome": "Health-related quality of life",
            "shortName": "Health-related quality of life",
            "importanceLevel": "NOTSET",
            "interventionReferenceType": "SYSTEMATIC_REVIEW",
            "interventionStudyType": "NOTSET",
            "comparatorStudyType": "NOTSET",
            "comparatorReferenceType": "PRIMARY_STUDY",
            "qualityInterventionStudyType": "NOTSET",
            "qualityOfEvidenceLevel": "LOW",
            "qualityOfEvidenceComment": "Due to very serious imprecision",
            "qualityRiskOfBias": "NOTSET",
            "qualityInconsistency": "NOTSET",
            "qualityIndirectness": "NOTSET",
            "qualityImprecision": "VERY_SERIOUS",
            "qualityPublicationBias": "NOTSET",
            "qualityUpgrade": "NOTSET",
            "plainSummaryComment": "SGLT2 inhibitors may have little or no impact on health-related quality of life.",
            "directionOfEffectType": "NOT_SET",
            "scaleDirection": "HIGH",
            "interventionEffect": "51.91",
            "interventionEffectType": "MEAN",
            "interventionEffectConfidenceType": "SD",
            "comparatorEffect": "51",
            "comparatorEffectType": "MEAN",
            "comparatorEffectConfidenceType": "SD",
            "comparatorEffectConfidenceLow": "7",
            "comparatorStudyData": [{
              "referenceStudyDataId": null,
              "outcomeId": 136749,
              "referenceId": 507287,
              "studyDataId": 176716,
              "revManStudyDataId": null,
              "autoAdd": false,
              "study": "Zurita-cruz 2018",
              "studyType": "",
              "followUp": "",
              "totalParticipants": null,
              "interventionParticipants": null,
              "comparatorParticipants": null,
              "weight": 0.0,
              "reference": {
                "referenceId": 507287,
                "referenceNumber": 5,
                "authors": [{
                  "id": 3541436,
                  "firstName": "Jessie N",
                  "lastName": "Zurita-Cruz",
                  "formattedName": "Zurita-Cruz JN"
                }, {
                  "id": 3541437,
                  "firstName": "Leticia",
                  "lastName": "Manuel-Apolinar",
                  "formattedName": "Manuel-Apolinar L"
                }, {
                  "id": 3541438,
                  "firstName": "María Luisa",
                  "lastName": "Arellano-Flores",
                  "formattedName": "Arellano-Flores ML"
                }, {
                  "id": 3541439,
                  "firstName": "Alejandro",
                  "lastName": "Gutierrez-Gonzalez",
                  "formattedName": "Gutierrez-Gonzalez A"
                }, {
                  "id": 3541440,
                  "firstName": "Alma Gloria",
                  "lastName": "Najera-Ahumada",
                  "formattedName": "Najera-Ahumada AG"
                }, {
                  "id": 3541441,
                  "firstName": "Nelly",
                  "lastName": "Cisneros-González",
                  "formattedName": "Cisneros-González N"
                }],
                "titleText": "Health and quality of life outcomes impairment of quality of life in type 2 diabetes mellitus: a cross-sectional study.",
                "url": "",
                "doi": "10.1186/s12955-018-0906-y",
                "pmid": "29764429",
                "journal": "Health and quality of life outcomes",
                "year": "2018",
                "volume": "16",
                "issue": "1",
                "pageStart": "94",
                "pageEnd": "",
                "creationType": "PUBMED",
                "guidelineId": 6704,
                "evidenceSummaryId": null,
                "shortName": "Zurita-cruz 2018",
                "order": 5,
                "referenceType": "PRIMARY_STUDY",
                "studyType": "NOT_SET",
                "attachedFiles": [],
                "abstractText": "BACKGROUND : Type 2 diabetes mellitus (DM2) is a chronic disease, and for treatment to succeed, it is necessary to harmonize the mental health of the patient with the environment, which impacts quality of life and adherence to medical regimens. The objetive of this study is describe the quality of life of patients with DM2 and the factors relates to its modification.\nMETHODS : This investigation was a cross-sectional study. Patients over 18 years of age with DM2 were selected. The following variables related to quality of life were studied: age, sex, occupation, marital status, years of DM2 evolution, comorbidities and presence of depression (Beck Depression Inventory). Perceived quality of life was measured with a health-related quality of life (HRQoL) scale, the 36-Item Short-Form Survey (SF-36). Patients were classified according to SF-36 HRQoL score (< 50, 51-75 and > 76 points).\nRESULTS : Among the 1394 patients included, the median age was 62 years. Global HRQoL had a median of 50.1 points. Bivariate analysis showed that age, marital status, sex, occupation, comorbidities, duration of DM2 and comorbidities had impacts on HRQoL. The logistic regression model identified age (odds ratio [OR] 1.04) and depression (OR 4.4) as independent factors that influenced overall quality of life.\nCONCLUSIONS : Patients with DM2 have poor HRQoL, which is associated with a high frequency of depression. Older age and the presence of depression impair patient HRQoL.\nTRIAL REGISTRATION : R-2013-781-052. Registered 20 December 2014.\n",
                "comments": "",
                "selected": false,
                "usageCount": null,
                "files": [],
                "results": ""
              },
              "absoluteEffectType": "SMD",
              "absoluteEffect": null,
              "absoluteEffectConfidenceLow": null,
              "absoluteEffectConfidenceHigh": null,
              "interventionEffect": null,
              "interventionEffectType": null,
              "interventionEffectConfidenceType": null,
              "interventionEffectConfidenceLow": null,
              "interventionEffectConfidenceHigh": null,
              "comparatorEffect": null,
              "comparatorEffectType": null,
              "comparatorEffectConfidenceType": null,
              "comparatorEffectConfidenceLow": null,
              "comparatorEffectConfidenceHigh": null,
              "referenceNumber": 5
            }],
            "absoluteDifferenceType": "SMD",
            "absoluteDifference": "0.14",
            "absoluteDifferenceDirection": "MORE",
            "absoluteDifferenceConfidenceType": "CI95",
            "absoluteDifferenceLow": "0.08",
            "absoluteDifferenceLowDirection": "FEW",
            "absoluteDifferenceHigh": "0.36",
            "absoluteDifferenceHighDirection": "MORE",
            "absoluteDifferenceDirectionType": "LOW_HIGH"
          }, {
            "outcomeId": 136750,
            "picoId": 113494,
            "sectionId": 116147,
            "status": "DEVELOPMENT",
            "isHidden": false,
            "autoCalc": true,
            "sortOrder": 20,
            "shortCode": "jOpMzG",
            "outcome": "Body weight",
            "shortName": "Body weight",
            "importanceLevel": "NOTSET",
            "interventionStudies": "439",
            "interventionTotalParticipants": 215590.0,
            "interventionReferenceType": "SYSTEMATIC_REVIEW",
            "interventionStudyType": "NOTSET",
            "comparatorStudyType": "NOTSET",
            "comparatorReferenceType": "PRIMARY_STUDY",
            "qualityInterventionStudyType": "NOTSET",
            "qualityOfEvidenceLevel": "LOW",
            "qualityOfEvidenceComment": "Due to very serious inconsistency",
            "qualityRiskOfBias": "NOTSET",
            "qualityInconsistency": "VERY_SERIOUS",
            "qualityIndirectness": "NOTSET",
            "qualityImprecision": "NOTSET",
            "qualityPublicationBias": "NOTSET",
            "qualityUpgrade": "NOTSET",
            "plainSummaryComment": "SGLT2 inhibitors may reduce body weight compared with standard care.",
            "directionOfEffectType": "NOT_SET",
            "scaleDirection": "LOW",
            "unit": "Kg",
            "interventionEffect": "86.08",
            "interventionEffectType": "MEAN",
            "interventionEffectConfidenceType": "SD",
            "comparatorEffect": "88",
            "comparatorEffectType": "MEAN",
            "comparatorEffectConfidenceType": "SD",
            "comparatorEffectConfidenceLow": "20",
            "absoluteDifferenceType": "MD",
            "absoluteDifference": "1.92",
            "absoluteDifferenceDirection": "FEW",
            "absoluteDifferenceConfidenceType": "CI95",
            "absoluteDifferenceLow": "2.23",
            "absoluteDifferenceLowDirection": "FEW",
            "absoluteDifferenceHigh": "1.62",
            "absoluteDifferenceHighDirection": "FEW",
            "absoluteDifferenceDirectionType": "LOW_HIGH"
          }],
          "nonPoolableOutcomes": [],
          "practicalIssues": []
        },
        "guidelineId": null,
        "evidenceSummaryId": null,
        "referenceId": [507287, 507288],
        "references": [{
          "referenceId": 507287,
          "referenceNumber": 5,
          "authors": [{
            "id": 3541436,
            "firstName": "Jessie N",
            "lastName": "Zurita-Cruz",
            "formattedName": "Zurita-Cruz JN"
          }, {
            "id": 3541437,
            "firstName": "Leticia",
            "lastName": "Manuel-Apolinar",
            "formattedName": "Manuel-Apolinar L"
          }, {
            "id": 3541438,
            "firstName": "María Luisa",
            "lastName": "Arellano-Flores",
            "formattedName": "Arellano-Flores ML"
          }, {
            "id": 3541439,
            "firstName": "Alejandro",
            "lastName": "Gutierrez-Gonzalez",
            "formattedName": "Gutierrez-Gonzalez A"
          }, {
            "id": 3541440,
            "firstName": "Alma Gloria",
            "lastName": "Najera-Ahumada",
            "formattedName": "Najera-Ahumada AG"
          }, {
            "id": 3541441,
            "firstName": "Nelly",
            "lastName": "Cisneros-González",
            "formattedName": "Cisneros-González N"
          }],
          "titleText": "Health and quality of life outcomes impairment of quality of life in type 2 diabetes mellitus: a cross-sectional study.",
          "url": "",
          "doi": "10.1186/s12955-018-0906-y",
          "pmid": "29764429",
          "journal": "Health and quality of life outcomes",
          "year": "2018",
          "volume": "16",
          "issue": "1",
          "pageStart": "94",
          "pageEnd": "",
          "creationType": "PUBMED",
          "guidelineId": 6704,
          "evidenceSummaryId": null,
          "shortName": "Zurita-cruz 2018",
          "order": 5,
          "referenceType": "PRIMARY_STUDY",
          "studyType": "NOT_SET",
          "attachedFiles": [],
          "abstractText": "BACKGROUND : Type 2 diabetes mellitus (DM2) is a chronic disease, and for treatment to succeed, it is necessary to harmonize the mental health of the patient with the environment, which impacts quality of life and adherence to medical regimens. The objetive of this study is describe the quality of life of patients with DM2 and the factors relates to its modification.\nMETHODS : This investigation was a cross-sectional study. Patients over 18 years of age with DM2 were selected. The following variables related to quality of life were studied: age, sex, occupation, marital status, years of DM2 evolution, comorbidities and presence of depression (Beck Depression Inventory). Perceived quality of life was measured with a health-related quality of life (HRQoL) scale, the 36-Item Short-Form Survey (SF-36). Patients were classified according to SF-36 HRQoL score (< 50, 51-75 and > 76 points).\nRESULTS : Among the 1394 patients included, the median age was 62 years. Global HRQoL had a median of 50.1 points. Bivariate analysis showed that age, marital status, sex, occupation, comorbidities, duration of DM2 and comorbidities had impacts on HRQoL. The logistic regression model identified age (odds ratio [OR] 1.04) and depression (OR 4.4) as independent factors that influenced overall quality of life.\nCONCLUSIONS : Patients with DM2 have poor HRQoL, which is associated with a high frequency of depression. Older age and the presence of depression impair patient HRQoL.\nTRIAL REGISTRATION : R-2013-781-052. Registered 20 December 2014.\n",
          "comments": "",
          "selected": false,
          "usageCount": null,
          "referencePicos": [],
          "files": [],
          "results": ""
        }, {
          "referenceId": 507288,
          "referenceNumber": 4,
          "authors": [{
            "id": 3541442,
            "firstName": "Ishan",
            "lastName": "Hirji",
            "formattedName": "Hirji I"
          }, {
            "id": 3541443,
            "firstName": "Susan W",
            "lastName": "Andersson",
            "formattedName": "Andersson SW"
          }, {
            "id": 3541444,
            "firstName": "Zhenchao",
            "lastName": "Guo",
            "formattedName": "Guo Z"
          }, {
            "id": 3541445,
            "firstName": "Niklas",
            "lastName": "Hammar",
            "formattedName": "Hammar N"
          }, {
            "id": 3541446,
            "firstName": "Andres",
            "lastName": "Gomez-Caminero",
            "formattedName": "Gomez-Caminero A"
          }],
          "titleText": "Incidence of genital infection among patients with type 2 diabetes in the UK General Practice Research Database.",
          "url": "",
          "doi": "10.1016/j.jdiacomp.2012.06.012",
          "pmid": "22840886",
          "journal": "Journal of diabetes and its complications",
          "year": "",
          "volume": "26",
          "issue": "6",
          "pageStart": "501-5",
          "pageEnd": "",
          "creationType": "PUBMED",
          "guidelineId": 6704,
          "evidenceSummaryId": null,
          "shortName": "Hirji",
          "order": 4,
          "referenceType": "PRIMARY_STUDY",
          "studyType": "NOT_SET",
          "attachedFiles": [],
          "abstractText": "The objective of this population-based study was to evaluate the incidence of vaginitis (females) and balanitis (males) among a cohort of type 2 diabetes patients and compare this risk to patients without diabetes. The study population included 125,237 female patients and 146,603 males identified from GPRD. All patients were followed for 1-year from their study index date for the first record of an infection or a censored event. Among patients with diabetes the incidence of vaginitis was 21.0/1000PY (95% CI 19.8-22.1) with the risk being 1.81 (95% CI 1.64-2.00) greater that patients without diabetes. The incidence of balanitis among diabetes patients was 8.4/1000PY (95% CI 7.8-9.1) with a relative risk of 2.85 (2.39-3.39) compared to patients without diabetes. Additional analyses were performed by HbA1c level. Results from this large population-based study indicate that patients with diabetes are at an increased risk of being diagnosed with infections of the genital tract and patients with poorly controlled diabetes have higher risks.\n",
          "comments": "",
          "selected": false,
          "usageCount": null,
          "referencePicos": [],
          "files": [],
          "results": ""
        }],
        "picoCodes": []
      }],
      "references": [{
        "referenceId": 507287,
        "referenceNumber": 5,
        "authors": [{
          "id": 3541436,
          "firstName": "Jessie N",
          "lastName": "Zurita-Cruz",
          "formattedName": "Zurita-Cruz JN"
        }, {
          "id": 3541437,
          "firstName": "Leticia",
          "lastName": "Manuel-Apolinar",
          "formattedName": "Manuel-Apolinar L"
        }, {
          "id": 3541438,
          "firstName": "María Luisa",
          "lastName": "Arellano-Flores",
          "formattedName": "Arellano-Flores ML"
        }, {
          "id": 3541439,
          "firstName": "Alejandro",
          "lastName": "Gutierrez-Gonzalez",
          "formattedName": "Gutierrez-Gonzalez A"
        }, {
          "id": 3541440,
          "firstName": "Alma Gloria",
          "lastName": "Najera-Ahumada",
          "formattedName": "Najera-Ahumada AG"
        }, {
          "id": 3541441,
          "firstName": "Nelly",
          "lastName": "Cisneros-González",
          "formattedName": "Cisneros-González N"
        }],
        "titleText": "Health and quality of life outcomes impairment of quality of life in type 2 diabetes mellitus: a cross-sectional study.",
        "url": "",
        "doi": "10.1186/s12955-018-0906-y",
        "pmid": "29764429",
        "journal": "Health and quality of life outcomes",
        "year": "2018",
        "volume": "16",
        "issue": "1",
        "pageStart": "94",
        "pageEnd": "",
        "creationType": "PUBMED",
        "guidelineId": 6704,
        "evidenceSummaryId": null,
        "shortName": "Zurita-cruz 2018",
        "order": 5,
        "referenceType": "PRIMARY_STUDY",
        "studyType": "NOT_SET",
        "attachedFiles": [],
        "abstractText": "BACKGROUND : Type 2 diabetes mellitus (DM2) is a chronic disease, and for treatment to succeed, it is necessary to harmonize the mental health of the patient with the environment, which impacts quality of life and adherence to medical regimens. The objetive of this study is describe the quality of life of patients with DM2 and the factors relates to its modification.\nMETHODS : This investigation was a cross-sectional study. Patients over 18 years of age with DM2 were selected. The following variables related to quality of life were studied: age, sex, occupation, marital status, years of DM2 evolution, comorbidities and presence of depression (Beck Depression Inventory). Perceived quality of life was measured with a health-related quality of life (HRQoL) scale, the 36-Item Short-Form Survey (SF-36). Patients were classified according to SF-36 HRQoL score (< 50, 51-75 and > 76 points).\nRESULTS : Among the 1394 patients included, the median age was 62 years. Global HRQoL had a median of 50.1 points. Bivariate analysis showed that age, marital status, sex, occupation, comorbidities, duration of DM2 and comorbidities had impacts on HRQoL. The logistic regression model identified age (odds ratio [OR] 1.04) and depression (OR 4.4) as independent factors that influenced overall quality of life.\nCONCLUSIONS : Patients with DM2 have poor HRQoL, which is associated with a high frequency of depression. Older age and the presence of depression impair patient HRQoL.\nTRIAL REGISTRATION : R-2013-781-052. Registered 20 December 2014.\n",
        "comments": "",
        "selected": false,
        "usageCount": null,
        "referencePicos": [],
        "files": [],
        "results": ""
      }, {
        "referenceId": 507288,
        "referenceNumber": 4,
        "authors": [{
          "id": 3541442,
          "firstName": "Ishan",
          "lastName": "Hirji",
          "formattedName": "Hirji I"
        }, {
          "id": 3541443,
          "firstName": "Susan W",
          "lastName": "Andersson",
          "formattedName": "Andersson SW"
        }, {
          "id": 3541444,
          "firstName": "Zhenchao",
          "lastName": "Guo",
          "formattedName": "Guo Z"
        }, {
          "id": 3541445,
          "firstName": "Niklas",
          "lastName": "Hammar",
          "formattedName": "Hammar N"
        }, {
          "id": 3541446,
          "firstName": "Andres",
          "lastName": "Gomez-Caminero",
          "formattedName": "Gomez-Caminero A"
        }],
        "titleText": "Incidence of genital infection among patients with type 2 diabetes in the UK General Practice Research Database.",
        "url": "",
        "doi": "10.1016/j.jdiacomp.2012.06.012",
        "pmid": "22840886",
        "journal": "Journal of diabetes and its complications",
        "year": "",
        "volume": "26",
        "issue": "6",
        "pageStart": "501-5",
        "pageEnd": "",
        "creationType": "PUBMED",
        "guidelineId": 6704,
        "evidenceSummaryId": null,
        "shortName": "Hirji",
        "order": 4,
        "referenceType": "PRIMARY_STUDY",
        "studyType": "NOT_SET",
        "attachedFiles": [],
        "abstractText": "The objective of this population-based study was to evaluate the incidence of vaginitis (females) and balanitis (males) among a cohort of type 2 diabetes patients and compare this risk to patients without diabetes. The study population included 125,237 female patients and 146,603 males identified from GPRD. All patients were followed for 1-year from their study index date for the first record of an infection or a censored event. Among patients with diabetes the incidence of vaginitis was 21.0/1000PY (95% CI 19.8-22.1) with the risk being 1.81 (95% CI 1.64-2.00) greater that patients without diabetes. The incidence of balanitis among diabetes patients was 8.4/1000PY (95% CI 7.8-9.1) with a relative risk of 2.85 (2.39-3.39) compared to patients without diabetes. Additional analyses were performed by HbA1c level. Results from this large population-based study indicate that patients with diabetes are at an increased risk of being diagnosed with infections of the genital tract and patients with poorly controlled diabetes have higher risks.\n",
        "comments": "",
        "selected": false,
        "usageCount": null,
        "referencePicos": [],
        "files": [],
        "results": ""
      }],
      "files": []
    }]
  }],
  "references": []
};

const MAGICfile2 = {
  "name": "Play Fevir BMJ Rapid Recommendations: Sodium-Glucose Transport Protein 2 (SGLT2) inhibitors and Glucagon-Like Peptide-1 (GLP-1) receptor agonists for type 2 diabetes",
  "byName": "SGLT2 inhibitors and GLP-1 RA for type 2 diabetes",
  "shortCode": "LryW8j",
  "owner": "MAGIC Evidence Ecosystem Foundation",
  "mainEditor": "Per Olav Vandvik",
  "startDate": "2022-10-07T00:00:00",
  "lastEdit": "2022-10-07T13:02:39",
  "language": "en",
  "countryFlag": "uk",
  "sponsors": "",
  "disclaimer": "",
  "description": "",
  "isbn": "",
  "issn": "",
  "orgDocId": "",
  "contactName": "",
  "contactAddress": "",
  "contactEmail": "",
  "contactTelephone": "",
  "contactWeb": "",
  "institutionId": 87,
  "institutionName": "MAGIC Evidence Ecosystem Foundation",
  "institutionLogoUrl": "https://files.magicapp.org/static/images/orgs/org_87.png",
  "institutionAltGrade": false,
  "guidelineId": 6704,
  "currentDraftId": 6704,
  "permission": 1,
  "isLatestPublished": false,
  "isDraftEditable": false,
  "isPublic": false,
  "versionMajor": 0,
  "versionMinor": 0,
  "draftPicoCount": 0,
  "draftRecommendationCount": 0,
  "publishedPicoCount": 0,
  "publishedRecommendationCount": 0,
  "contentAdmin": false,
  "status": "NOTSET",
  "commentsInPublished": true,
  "trackChanges": false,
  "sectionNumbers": true,
  "showRecByline": true,
  "showConflicts": true,
  "showCertaintyStrengthLabels": false,
  "showSectionPreview": false,
  "defaultKeyInfoType": "SUMMARY",
  "sections": [{
    "sectionId": 116150,
    "parentId": 116145,
    "order": 5,
    "shortCode": "jOpRXx",
    "sectionLabel": "4.5",
    "heading": "Patients with CVD and CKD",
    "text": "",
    "hasChildren": false,
    "counts": {
      "picoCount": 2,
      "recommendationCount": 2
    },
    "hasUncommittedChanges": false,
    "guidelineId": 6704,
    "subSections": [],
    "picos": [],
    "recommendations": [{
      "recommendationId": 133589,
      "shortCode": "Ega3bG",
      "guidelineId": 6704,
      "sectionId": 116150,
      "order": 3,
      "strength": "WEAK",
      "status": "NOTSET",
      "statusDate": null,
      "statusComment": null,
      "heading": "",
      "text": "We suggest starting GLP-1 receptor agonists.",
      "remarks": "The MATCH-IT decision support tool allows you to interact with the evidence and your patients across the alternative options:&nbsp;<a href=\"http://magicproject.org/200521dist/\">http://magicproject.org/200521dist/</a>",
      "advice": "<strong>Medication Routine</strong><br>\n&nbsp;<br>\nThe common form of the GLP-1 receptor agonists involves one (eg. liraglutide and lixisenatide) or two (eg. exenatide) daily subcutaneous injections; new preparations require only weekly injections (eg. albiglutide, dulaglutide, exenatide synthetic, and semaglutide). Oral semaglutide tablet is now approved by the United States Food and Drug Administration (FDA) and Health Canada, but not widely accessible in other countries.&nbsp; A compound preparation of GLP-1 receptor agonists and insulin is available and may not require increasing the frequency of injection. &nbsp;Our recommendation regarding GLP-1 receptor agonists is mainly based on the once-daily preparation.<br>\n&nbsp;<br>\nSGLT-2 inhibitors are oral medicines.<br>\n&nbsp;<br>\nMost anti-diabetic medications sould not be taken while a person is sick, especially if there is vomiting, diarrhoea, or the person isn’t eating and drinking very much. Most anti-diabetic medications are tablets except insulin, an injection. Insulin can be used while a person is sick and needs glucose-lowering medication.<br>\n&nbsp;<br>\n<strong>Test and visit</strong><br>\n&nbsp;<br>\nRegular blood samples, and more frequently after starting a new medication. We only consider adding these medications when the patient has HbA1C above 6.5.<br>\n&nbsp;<br>\nSGLT-2 inhibitors: needs to monitor blood pressure and kidney function.<br>\n&nbsp;<br>\nUsual care: needs self-monitoring of blood glucose at home if the patients are receiving insulin, sulfonylureas, or meglitinides.<br>\n&nbsp;<br>\n<strong>Recovery and adaptation</strong><br>\n&nbsp;<br>\nMost people need to take diabetes medications for the rest of their lives.<br>\n&nbsp;<br>\n<strong>Adverse effects, interactions, and antidote</strong><br>\n&nbsp;<br>\nSGLT-2 inhibitors or GLP-1 RAs do not increase the risk of hypoglycaemia when taken alone. But they do increase the risk of hypoglycaemia increase when used in combination with some medications such as insulin or insulin secretagogues.<br>\n&nbsp;<br>\nSGLT-2 inhibitors<br>\nMild to moderate genital infections can occur. Low blood pressure, dizziness, dehydration, etc., especially among people older than 65 years or when combined with diuretics. All patients should monitor for signs of diabetic ketoacidosis (even if the blood glucose is within the normal range) and seek hospital attention immediately if it occurs.<br>\n&nbsp;<br>\nGLP-1 RAs<br>\nDose-dependent gastrointestinal adverse reactions, including nausea, vomiting, diarrhoea, abdominal pain, indigestion, decreased appetite. These effects are usually most pronounced in the first few weeks after beginning medication and should be put to special caution in. patients with inflammatory bowel diseases or diabetic gastroparesis. Acute pancreatitis is a rare but serious adverse effect that can occur. GLP-RAs should not be used in combination with DPP-4 inhibitors.<br>\n&nbsp;<br>\nOther anti-diabetic medications<br>\n&nbsp;<br>\nAdverse effects vary between specific agents, especially for insulin or insulin secretagogues can cause low blood sugar.<br>\n&nbsp;<br>\n<strong>Physical well-being</strong><br>\n&nbsp;<br>\nBoth SGLT-2 inhibitors and GLP-1 RAs have a weight loss effect.<br>\n&nbsp;<br>\nWeight gain: sulfonylurea, thiazolidinediones, meglitinides, and insulin.<br>\n&nbsp;<br>\n<strong>Pregnancy and nursing</strong><br>\n&nbsp;<br>\nBoth SGLT-2 inhibitors and GLP-1 RAs should be avoided during pregnancy and nursing, or in women who may become pregnant.<br>\n&nbsp;<br>\nLifestyle intervention and human insulin can be considered during pregnancy and nursing. Glibenclamide, metformin, and insulin analogues can be considered in some countries such as the US.<br>\n&nbsp;<br>\n<strong>Costs and access</strong><br>\n&nbsp;<br>\nCosts vary between specific agents and depend on health insurance and policy. GLP-1 RAs are usually 2 to 3 times more expensive than SGLT-2 inhibitors.<br>\n&nbsp;<br>\nMetformin and sulfonylureas are usually inexpensive and easy to access.<br>\n&nbsp;<br>\n<strong>Food and drinks</strong><br>\n&nbsp;<br>\nDrinking more water may be helpful for patients receiving SGLT-2 inhibitors and prevent thirstily and dehydration. Dietary control is advised to control body weight.<br>\n&nbsp;<br>\n<strong>Storage and transportation before use</strong><br>\n&nbsp;<br>\nGLP-1 RAs and insulin should be stored and transported between 2℃ to 8℃ before the first use.<br>\n&nbsp;<br>\n<strong>Exercise and activities</strong><br>\n&nbsp;<br>\nModerate exercise and activities are advised.<br>\n&nbsp;<br>\n<strong>Travel time and driving</strong><br>\n&nbsp;<br>\nPatients at risk for undetected symptomatic hypoglycaemia need to be aware of the risk of driving. Patients using GLP-1 receptor agonists and insulin may need a special package to bring their medications and their injection equipment when travelling. The medications should be stored below 30℃ (25℃ for exenatide and benaglutide) avoiding sunshine and freezing after the first use.<br>\n&nbsp;<br>\n<strong>Baseline kidney function</strong><br>\n&nbsp;<br>\nThe FDA label suggests that empagliflozin should not be used in patients with eGFR below 45 mL/min/1.73 m2, and canagliflozin, ertugliflozin, and dapagliflozin should not be used in patients with eGFR below 30 mL/min/1.73 m2. All SGLT-2 inhibitors are contraindicated in patients with kidney failure or dialysis.<br>\n&nbsp;",
      "rational": "The guideline panel concluded that GLP-1 receptor agonists confer a benefit on critical outcomes such as cardiovascular mortality, myocardial infarctions, stroke and end-stage renal disease, but may increase gastrointestinal events and warrant injection-therapy, a burden for patients. The panel believed the majority of well-informed patients would elect to add GLP-1 receptor agonists to existing treatments for diabetes type II and cardiovascular and renal protection, but an appreciable minority may not want to take this treatment. This suggests the need for well-informed decisions, and ideally shared decision-making between doctors and patients.&nbsp;<br>\n<br>\nThe guideline panel concluded that SGLT2 inhibitors and GLP-1 receptor agonists confer a clear benefit on critical outcomes such as cardiovascular mortality, myocardial infarctions and end-stage renal disease, with additional benefits on heart failure and stroke and specific harms varying by drug class. The panel believed all or nearly all well-informed patients would elect to add one of these drugs to existing treatments for diabetes type II and cardiovascular and renal protection.&nbsp;",
      "adaptation": "",
      "implementation": "",
      "evaluation": "",
      "research": "",
      "keyInfoType": "SUMMARY",
      "keyInfoDisplayMode": "TEXT",
      "showAdaptation": false,
      "hideInPublish": false,
      "tags": null,
      "keyInfo": {
        "keyInfoType": "SUMMARY",
        "recommendationId": 133589,
        "guidelineId": null,
        "benefits": "Over five years and when compared to standard care: GLP-1 receptor agonists reduce overall mortality (24 fewer deaths/ 1000), myocardial infarctions (13 fewer/ 1000), stroke (29 fewer/ 1000), end-stage kidney disease (25 fewer/1000), heart failure hospitalisations (13 fewer/1000) and body weight (1.4 kg weight loss). GLP-1 receptor agonists may increase severe gastrointestinal adverse events ( 53more /1000) with no apparent differences in diabetic ketoacidosis or other patient-important outcomes.",
        "benefitsResearchEvidence": "",
        "benefitsResearchEvidenceInPublic": false,
        "benefitsAdditionalConsideration": "",
        "benefitsAdditionalConsiderationInPublic": false,
        "evidence": "Moderate to high certainty evidence for all benefit outcomes, very low certainty for gastrointestinal events",
        "evidenceResearchEvidence": "",
        "evidenceResearchEvidenceInPublic": false,
        "evidenceAdditionalConsideration": "",
        "evidenceAdditionalConsiderationInPublic": false,
        "preferences": "Based on the systematic review of patient values and preferences, a focus group with patients and a survey of panel members the panel concluded that a majority of patients likely would want to take GLP-1 receptor agonists. After careful deliberations concerning benefits weighed against the increase in gastrointestinal events and practical issues (injection therapy) related to adding another drug, the panel found this to represent a fine balance warranting well-informed decisions and ideally shared decision-making with patients.",
        "preferencesResearchEvidence": "",
        "preferencesResearchEvidenceInPublic": false,
        "preferencesAdditionalConsideration": "",
        "preferencesAdditionalConsiderationInPublic": false,
        "resources": "This guideline applied an individual patient perspective, realising that GLP-1 receptor agonists are costly and may not be covered/ reimbursed by health care systems. Cost-effectiveness was not assessed and patients having to pay out of pocket may elect not to add such treatment.",
        "resourcesResearchEvidence": "",
        "resourcesResearchEvidenceInPublic": false,
        "resourcesAdditionalConsideration": "",
        "resourcesAdditionalConsiderationInPublic": false,
        "benefitsStrength": "STRONG",
        "evidenceStrength": "MODERATE",
        "preferencesStrength": "WEAK",
        "resourcesStrength": "NOT_CONSIDERED",
        "interventions": [{
          "recommendationId": 133589,
          "picoId": 113501,
          "picoElement": "I",
          "intervention": "Glucagon-Like Peptide-1 (GLP-1) receptor agonists",
          "isComparator": false,
          "showComparator": true,
          "sortOrder": 9999,
          "judgements": {
            "BENEFITS_DESIRABLE": "NOT_SET",
            "BENEFITS_UNDESIRABLE": "NOT_SET",
            "EVIDENCE": "NOT_SET",
            "PREFERENCES": "WEAK",
            "RESOURCES": "NOT_SET"
          },
          "comparator": false
        }, {
          "recommendationId": 133589,
          "picoId": 113501,
          "picoElement": "C",
          "intervention": "Standard care",
          "isComparator": false,
          "showComparator": true,
          "sortOrder": 9999,
          "judgements": {
            "BENEFITS_DESIRABLE": "NOT_SET",
            "BENEFITS_UNDESIRABLE": "NOT_SET",
            "EVIDENCE": "NOT_SET",
            "PREFERENCES": "WEAK",
            "RESOURCES": "NOT_SET"
          },
          "comparator": false
        }],
        "isSummaryOfJudgementPublic": false
      },
      "interventions": {
        "recommendationId": 133589,
        "shortCode": "Ega3bG",
        "guidelineId": 6704,
        "sectionId": 116150,
        "emrImplement": "",
        "emrResources": "",
        "targetPopulation": "",
        "recommendedInvention": "",
        "codes": []
      },
      "emrCodes": [],
      "referenceId": [],
      "picoId": [113501],
      "picos": [{
        "picoId": 113501,
        "sectionId": 116150,
        "order": 2,
        "population": "Adults with type 2 diabetes and CVD and CKD",
        "populationShortName": "Adults with type 2 diabetes + CVD + CKD",
        "intervention": "Glucagon-Like Peptide-1 (GLP-1) receptor agonists",
        "interventionShortName": "GLP-1 RA",
        "comparator": "Standard care",
        "comparatorShortName": "Standard care",
        "shortCode": "Egag53",
        "summary": "",
        "outcomes": {
          "picoId": 113501,
          "sectionId": 116150,
          "dichotomousOutcomes": [{
            "outcomeId": 451254,
            "picoId": 113501,
            "sectionId": 116150,
            "status": "DEVELOPMENT",
            "isHidden": false,
            "autoCalc": true,
            "sortOrder": 10,
            "shortCode": "j2bQvZ",
            "outcome": "All-cause mortality",
            "shortName": "All-cause mortality",
            "importanceLevel": "NOTSET",
            "interventionStudies": "34",
            "interventionTotalParticipants": 69035.0,
            "interventionReferenceType": "SYSTEMATIC_REVIEW",
            "interventionStudyType": "RANDOMISED_CONTROLLED_TRIALS",
            "comparatorStudyType": "NOTSET",
            "comparatorReferenceType": "COMPARATOR_ARM",
            "qualityInterventionStudyType": "RANDOMISED_CONTROLLED_TRIALS",
            "qualityOfEvidenceLevel": "HIGH",
            "qualityRiskOfBias": "NOTSET",
            "qualityInconsistency": "NOTSET",
            "qualityIndirectness": "NOTSET",
            "qualityImprecision": "NOTSET",
            "qualityPublicationBias": "NOTSET",
            "qualityUpgrade": "NOTSET",
            "plainSummaryComment": "GLP-1 receptor agonists reduce the risk of death compared with standard care.",
            "directionOfEffectType": "NOT_SET",
            "absoluteDifference": 24.0,
            "absoluteDifferenceDirection": "FEW",
            "absoluteDifferenceConfidenceType": "CI95",
            "absoluteDifferenceLow": 35.0,
            "absoluteDifferenceLowDirection": "FEW",
            "absoluteDifferenceHigh": 12.0,
            "absoluteDifferenceHighDirection": "FEW",
            "relativeEffect": 0.88,
            "relativeEffectType": "OR",
            "relativeEffectConfidenceType": "CI95",
            "relativeEffectConfidenceLow": 0.83,
            "relativeEffectConfidenceHigh": 0.94,
            "comparatorEffect": 265.0,
            "comparatorEffectType": "PER_THOUSAND",
            "interventionEffect": 241.0,
            "interventionEffectType": "PER_THOUSAND",
            "autoCalcInterventions": "MANUAL"
          }, {
            "outcomeId": 451255,
            "picoId": 113501,
            "sectionId": 116150,
            "status": "DEVELOPMENT",
            "isHidden": false,
            "autoCalc": true,
            "sortOrder": 20,
            "shortCode": "EPKYmq",
            "outcome": "Cardiovascular mortality",
            "shortName": "Cardiovascular mortality",
            "importanceLevel": "NOTSET",
            "interventionStudies": "20",
            "interventionTotalParticipants": 63455.0,
            "interventionReferenceType": "SYSTEMATIC_REVIEW",
            "interventionStudyType": "RANDOMISED_CONTROLLED_TRIALS",
            "comparatorStudyType": "NOTSET",
            "comparatorReferenceType": "COMPARATOR_ARM",
            "qualityInterventionStudyType": "RANDOMISED_CONTROLLED_TRIALS",
            "qualityOfEvidenceLevel": "MODERATE",
            "qualityOfEvidenceComment": "Due to serious imprecision",
            "qualityRiskOfBias": "NOTSET",
            "qualityInconsistency": "NOTSET",
            "qualityIndirectness": "NOTSET",
            "qualityImprecision": "NOTSET",
            "qualityPublicationBias": "NOTSET",
            "qualityUpgrade": "NOTSET",
            "plainSummaryComment": "GLP-1 receptor agonists probably reduce the risk of cardiovascular death compared with standard care.",
            "directionOfEffectType": "NOT_SET",
            "absoluteDifference": 18.0,
            "absoluteDifferenceDirection": "FEW",
            "absoluteDifferenceConfidenceType": "CI95",
            "absoluteDifferenceLow": 30.0,
            "absoluteDifferenceLowDirection": "FEW",
            "absoluteDifferenceHigh": 6.0,
            "absoluteDifferenceHighDirection": "FEW",
            "relativeEffect": 0.88,
            "relativeEffectType": "OR",
            "relativeEffectConfidenceType": "CI95",
            "relativeEffectConfidenceLow": 0.8,
            "relativeEffectConfidenceHigh": 0.96,
            "comparatorEffect": 175.0,
            "comparatorEffectType": "PER_THOUSAND",
            "interventionEffect": 157.0,
            "interventionEffectType": "PER_THOUSAND",
            "autoCalcInterventions": "MANUAL"
          }, {
            "outcomeId": 451256,
            "picoId": 113501,
            "sectionId": 116150,
            "status": "DEVELOPMENT",
            "isHidden": false,
            "autoCalc": true,
            "sortOrder": 30,
            "shortCode": "LAKk5Y",
            "outcome": "Nonfatal myocardial infarction",
            "shortName": "Nonfatal myocardial infarction",
            "interventionStudies": "32",
            "interventionTotalParticipants": 67956.0,
            "interventionReferenceType": "SYSTEMATIC_REVIEW",
            "interventionStudyType": "RANDOMISED_CONTROLLED_TRIALS",
            "comparatorStudyType": "NOTSET",
            "comparatorReferenceType": "COMPARATOR_ARM",
            "qualityInterventionStudyType": "RANDOMISED_CONTROLLED_TRIALS",
            "qualityOfEvidenceLevel": "MODERATE",
            "qualityOfEvidenceComment": "Due to serious imprecision",
            "qualityRiskOfBias": "NOTSET",
            "qualityInconsistency": "NOTSET",
            "qualityIndirectness": "NOTSET",
            "qualityImprecision": "NOTSET",
            "qualityPublicationBias": "NOTSET",
            "qualityUpgrade": "NOTSET",
            "plainSummaryComment": "GLP-1 receptor agonists probably reduce the risk of nonfatal myocardial infarction compared with standard care.",
            "directionOfEffectType": "NOT_SET",
            "absoluteDifference": 13.0,
            "absoluteDifferenceDirection": "FEW",
            "absoluteDifferenceConfidenceType": "CI95",
            "absoluteDifferenceLow": 24.0,
            "absoluteDifferenceLowDirection": "FEW",
            "absoluteDifferenceHigh": 2.0,
            "absoluteDifferenceHighDirection": "FEW",
            "relativeEffect": 0.92,
            "relativeEffectType": "OR",
            "relativeEffectConfidenceType": "CI95",
            "relativeEffectConfidenceLow": 0.85,
            "relativeEffectConfidenceHigh": 0.99,
            "comparatorEffect": 190.0,
            "comparatorEffectType": "PER_THOUSAND",
            "interventionEffect": 177.0,
            "interventionEffectType": "PER_THOUSAND",
            "autoCalcInterventions": "MANUAL"
          }, {
            "outcomeId": 451257,
            "picoId": 113501,
            "sectionId": 116150,
            "status": "DEVELOPMENT",
            "isHidden": false,
            "autoCalc": true,
            "sortOrder": 40,
            "shortCode": "Lp1mP5",
            "outcome": "Nonfatal stroke",
            "shortName": "Nonfatal stroke",
            "interventionStudies": "29",
            "interventionTotalParticipants": 66900.0,
            "interventionReferenceType": "SYSTEMATIC_REVIEW",
            "interventionStudyType": "RANDOMISED_CONTROLLED_TRIALS",
            "comparatorStudyType": "NOTSET",
            "comparatorReferenceType": "COMPARATOR_ARM",
            "qualityInterventionStudyType": "RANDOMISED_CONTROLLED_TRIALS",
            "qualityOfEvidenceLevel": "HIGH",
            "qualityRiskOfBias": "NOTSET",
            "qualityInconsistency": "NOTSET",
            "qualityIndirectness": "NOTSET",
            "qualityImprecision": "NOTSET",
            "qualityPublicationBias": "NOTSET",
            "qualityUpgrade": "NOTSET",
            "plainSummaryComment": "GLP-1 receptor agonists reduce the risk of nonfatal stroke compared with standard care.",
            "directionOfEffectType": "NOT_SET",
            "absoluteDifference": 25.0,
            "absoluteDifferenceDirection": "FEW",
            "absoluteDifferenceConfidenceType": "CI95",
            "absoluteDifferenceLow": 39.0,
            "absoluteDifferenceLowDirection": "FEW",
            "absoluteDifferenceHigh": 11.0,
            "absoluteDifferenceHighDirection": "FEW",
            "relativeEffect": 0.84,
            "relativeEffectType": "OR",
            "relativeEffectConfidenceType": "CI95",
            "relativeEffectConfidenceLow": 0.76,
            "relativeEffectConfidenceHigh": 0.93,
            "comparatorEffect": 190.0,
            "comparatorEffectType": "PER_THOUSAND",
            "interventionEffect": 165.0,
            "interventionEffectType": "PER_THOUSAND",
            "autoCalcInterventions": "MANUAL"
          }, {
            "outcomeId": 451258,
            "picoId": 113501,
            "sectionId": 116150,
            "status": "DEVELOPMENT",
            "isHidden": false,
            "autoCalc": true,
            "sortOrder": 50,
            "shortCode": "LG4kbw",
            "outcome": "End-stage kidney disease",
            "shortName": "End-stage kidney disease",
            "interventionStudies": "4",
            "interventionTotalParticipants": 10762.0,
            "interventionReferenceType": "SYSTEMATIC_REVIEW",
            "interventionStudyType": "RANDOMISED_CONTROLLED_TRIALS",
            "comparatorStudyType": "NOTSET",
            "comparatorReferenceType": "COMPARATOR_ARM",
            "qualityInterventionStudyType": "RANDOMISED_CONTROLLED_TRIALS",
            "qualityOfEvidenceLevel": "HIGH",
            "qualityRiskOfBias": "NOTSET",
            "qualityInconsistency": "NOTSET",
            "qualityIndirectness": "NOTSET",
            "qualityImprecision": "NOTSET",
            "qualityPublicationBias": "NOTSET",
            "qualityUpgrade": "NOTSET",
            "plainSummaryComment": "GLP-1 receptor agonists reduce the risk of end-stage kidney disease compared with standard care.",
            "directionOfEffectType": "NOT_SET",
            "absoluteDifference": 29.0,
            "absoluteDifferenceDirection": "FEW",
            "absoluteDifferenceConfidenceType": "CI95",
            "absoluteDifferenceLow": 44.0,
            "absoluteDifferenceLowDirection": "FEW",
            "absoluteDifferenceHigh": 10.0,
            "absoluteDifferenceHighDirection": "FEW",
            "relativeEffect": 0.78,
            "relativeEffectType": "OR",
            "relativeEffectConfidenceType": "CI95",
            "relativeEffectConfidenceLow": 0.67,
            "relativeEffectConfidenceHigh": 0.92,
            "comparatorEffect": 148.0,
            "comparatorEffectType": "PER_THOUSAND",
            "interventionEffect": 119.0,
            "interventionEffectType": "PER_THOUSAND",
            "autoCalcInterventions": "MANUAL"
          }, {
            "outcomeId": 451259,
            "picoId": 113501,
            "sectionId": 116150,
            "status": "DEVELOPMENT",
            "isHidden": false,
            "autoCalc": true,
            "sortOrder": 60,
            "shortCode": "E830vb",
            "outcome": "Heart failure",
            "shortName": "Hospital admission for heart failure",
            "importanceLevel": "NOTSET",
            "interventionStudies": "13",
            "interventionTotalParticipants": 46696.0,
            "interventionReferenceType": "SYSTEMATIC_REVIEW",
            "interventionStudyType": "RANDOMISED_CONTROLLED_TRIALS",
            "comparatorStudyType": "NOTSET",
            "comparatorReferenceType": "COMPARATOR_ARM",
            "qualityInterventionStudyType": "RANDOMISED_CONTROLLED_TRIALS",
            "qualityOfEvidenceLevel": "MODERATE",
            "qualityOfEvidenceComment": "Due to serious imprecision",
            "qualityRiskOfBias": "NOTSET",
            "qualityInconsistency": "NOTSET",
            "qualityIndirectness": "NOTSET",
            "qualityImprecision": "NOTSET",
            "qualityPublicationBias": "NOTSET",
            "qualityUpgrade": "NOTSET",
            "plainSummaryComment": "GLP-1 receptor agonists probably reduce the risk of heart failure compared with standard care.",
            "directionOfEffectType": "NOT_SET",
            "absoluteDifference": 11.0,
            "absoluteDifferenceDirection": "FEW",
            "absoluteDifferenceConfidenceType": "CI95",
            "absoluteDifferenceLow": 28.0,
            "absoluteDifferenceLowDirection": "FEW",
            "absoluteDifferenceHigh": 5.0,
            "absoluteDifferenceHighDirection": "MORE",
            "relativeEffect": 0.94,
            "relativeEffectType": "OR",
            "relativeEffectConfidenceType": "CI95",
            "relativeEffectConfidenceLow": 0.85,
            "relativeEffectConfidenceHigh": 1.03,
            "comparatorEffect": 235.0,
            "comparatorEffectType": "PER_THOUSAND",
            "interventionEffect": 224.0,
            "interventionEffectType": "PER_THOUSAND",
            "autoCalcInterventions": "MANUAL"
          }, {
            "outcomeId": 451260,
            "picoId": 113501,
            "sectionId": 116150,
            "status": "DEVELOPMENT",
            "isHidden": false,
            "autoCalc": true,
            "sortOrder": 70,
            "shortCode": "jlAPmx",
            "outcome": "Serious hyperglycaemia",
            "shortName": "Serious hyperglycaemia",
            "interventionStudies": "12",
            "interventionTotalParticipants": 30066.0,
            "interventionReferenceType": "SYSTEMATIC_REVIEW",
            "interventionStudyType": "NOTSET",
            "comparatorStudyType": "NOTSET",
            "comparatorReferenceType": "COMPARATOR_ARM",
            "qualityInterventionStudyType": "NOTSET",
            "qualityOfEvidenceLevel": "HIGH",
            "qualityRiskOfBias": "NOTSET",
            "qualityInconsistency": "NOTSET",
            "qualityIndirectness": "NOTSET",
            "qualityImprecision": "NOTSET",
            "qualityPublicationBias": "NOTSET",
            "qualityUpgrade": "NOTSET",
            "plainSummaryComment": "GLP-1 receptor agonists reduce the risk of serious hyperglycaemia compared with standard care.",
            "directionOfEffectType": "NOT_SET",
            "absoluteDifference": 15.0,
            "absoluteDifferenceDirection": "FEW",
            "absoluteDifferenceConfidenceType": "CI95",
            "absoluteDifferenceLow": 19.0,
            "absoluteDifferenceLowDirection": "FEW",
            "absoluteDifferenceHigh": 9.0,
            "absoluteDifferenceHighDirection": "FEW",
            "relativeEffect": 0.4,
            "relativeEffectType": "OR",
            "relativeEffectConfidenceType": "CI95",
            "relativeEffectConfidenceLow": 0.25,
            "relativeEffectConfidenceHigh": 0.64,
            "comparatorEffect": 25.0,
            "comparatorEffectType": "PER_THOUSAND",
            "interventionEffect": 10.0,
            "interventionEffectType": "PER_THOUSAND",
            "autoCalcInterventions": "MANUAL"
          }, {
            "outcomeId": 451261,
            "picoId": 113501,
            "sectionId": 116150,
            "status": "DEVELOPMENT",
            "isHidden": false,
            "autoCalc": true,
            "sortOrder": 80,
            "shortCode": "ERxp02",
            "outcome": "Severe gastrointestinal events",
            "shortName": "Severe gastrointestinal events",
            "importanceLevel": "NOTSET",
            "interventionStudies": "7",
            "interventionTotalParticipants": 24638.0,
            "interventionReferenceType": "SYSTEMATIC_REVIEW",
            "interventionStudyType": "RANDOMISED_CONTROLLED_TRIALS",
            "comparatorStudyType": "NOTSET",
            "comparatorReferenceType": "COMPARATOR_ARM",
            "qualityInterventionStudyType": "RANDOMISED_CONTROLLED_TRIALS",
            "qualityOfEvidenceLevel": "LOW",
            "qualityOfEvidenceComment": "Due to inconsistency and serious imprecision",
            "qualityRiskOfBias": "NOTSET",
            "qualityInconsistency": "SERIOUS",
            "qualityIndirectness": "NOTSET",
            "qualityImprecision": "NOTSET",
            "qualityPublicationBias": "NOTSET",
            "qualityUpgrade": "NOTSET",
            "plainSummaryComment": "GLP-1 receptor agonists may increase the risk of severe gastrointestinal events compared with standard care.",
            "directionOfEffectType": "NOT_SET",
            "absoluteDifference": 58.0,
            "absoluteDifferenceDirection": "MORE",
            "absoluteDifferenceConfidenceType": "CI95",
            "absoluteDifferenceLow": 9.0,
            "absoluteDifferenceLowDirection": "MORE",
            "absoluteDifferenceHigh": 142.0,
            "absoluteDifferenceHighDirection": "MORE",
            "relativeEffect": 2.46,
            "relativeEffectType": "OR",
            "relativeEffectConfidenceType": "CI95",
            "relativeEffectConfidenceLow": 1.22,
            "relativeEffectConfidenceHigh": 4.97,
            "comparatorEffect": 44.0,
            "comparatorEffectType": "PER_THOUSAND",
            "interventionEffect": 102.0,
            "interventionEffectType": "PER_THOUSAND",
            "autoCalcInterventions": "MANUAL"
          }],
          "continuousOutcomes": [{
            "outcomeId": 136763,
            "picoId": 113501,
            "sectionId": 116150,
            "status": "DEVELOPMENT",
            "isHidden": false,
            "autoCalc": true,
            "sortOrder": 10,
            "shortCode": "EvwPXY",
            "outcome": "Health-related quality of life",
            "shortName": "Health-related quality of life",
            "importanceLevel": "NOTSET",
            "interventionReferenceType": "SYSTEMATIC_REVIEW",
            "interventionStudyType": "NOTSET",
            "comparatorStudyType": "NOTSET",
            "comparatorReferenceType": "COMPARATOR_ARM",
            "qualityInterventionStudyType": "NOTSET",
            "qualityOfEvidenceLevel": "LOW",
            "qualityOfEvidenceComment": "Due to very serious imprecision",
            "qualityRiskOfBias": "NOTSET",
            "qualityInconsistency": "NOTSET",
            "qualityIndirectness": "NOTSET",
            "qualityImprecision": "VERY_SERIOUS",
            "qualityPublicationBias": "NOTSET",
            "qualityUpgrade": "NOTSET",
            "plainSummaryComment": "GLP-1 receptor agonists may have little or no impact on health-related quality of life.",
            "directionOfEffectType": "NOT_SET",
            "scaleDirection": "HIGH",
            "interventionEffect": "51.91",
            "interventionEffectType": "MEAN",
            "interventionEffectConfidenceType": "SD",
            "comparatorEffect": "51",
            "comparatorEffectType": "MEAN",
            "comparatorEffectConfidenceType": "SD",
            "comparatorEffectConfidenceLow": "7",
            "absoluteDifferenceType": "SMD",
            "absoluteDifference": "0.13",
            "absoluteDifferenceDirection": "MORE",
            "absoluteDifferenceConfidenceType": "CI95",
            "absoluteDifferenceLow": "0.03",
            "absoluteDifferenceLowDirection": "MORE",
            "absoluteDifferenceHigh": "0.23",
            "absoluteDifferenceHighDirection": "MORE",
            "absoluteDifferenceDirectionType": "LOW_HIGH"
          }, {
            "outcomeId": 136764,
            "picoId": 113501,
            "sectionId": 116150,
            "status": "DEVELOPMENT",
            "isHidden": false,
            "autoCalc": true,
            "sortOrder": 20,
            "shortCode": "jN2lXv",
            "outcome": "Body weight",
            "shortName": "Body weight",
            "importanceLevel": "NOTSET",
            "interventionStudies": "60",
            "interventionTotalParticipants": 44432.0,
            "interventionReferenceType": "SYSTEMATIC_REVIEW",
            "interventionStudyType": "NOTSET",
            "comparatorStudyType": "NOTSET",
            "comparatorReferenceType": "COMPARATOR_ARM",
            "qualityInterventionStudyType": "NOTSET",
            "qualityOfEvidenceLevel": "LOW",
            "qualityOfEvidenceComment": "Due to very serious inconsistency",
            "qualityRiskOfBias": "NOTSET",
            "qualityInconsistency": "VERY_SERIOUS",
            "qualityIndirectness": "NOTSET",
            "qualityImprecision": "NOTSET",
            "qualityPublicationBias": "NOTSET",
            "qualityUpgrade": "NOTSET",
            "plainSummaryComment": "GLP-1 receptor agonists may reduce body weight compared with standard care.",
            "directionOfEffectType": "NOT_SET",
            "scaleDirection": "LOW",
            "unit": "Kg",
            "interventionEffect": "86.55",
            "interventionEffectType": "MEAN",
            "interventionEffectConfidenceType": "SD",
            "comparatorEffect": "88",
            "comparatorEffectType": "MEAN",
            "comparatorEffectConfidenceType": "SD",
            "comparatorEffectConfidenceLow": "20",
            "absoluteDifferenceType": "MD",
            "absoluteDifference": "1.45",
            "absoluteDifferenceDirection": "FEW",
            "absoluteDifferenceConfidenceType": "CI95",
            "absoluteDifferenceLow": "1.72",
            "absoluteDifferenceLowDirection": "FEW",
            "absoluteDifferenceHigh": "1.18",
            "absoluteDifferenceHighDirection": "FEW",
            "absoluteDifferenceDirectionType": "LOW_HIGH"
          }],
          "nonPoolableOutcomes": [],
          "practicalIssues": []
        },
        "guidelineId": null,
        "evidenceSummaryId": null,
        "referenceId": [],
        "references": [],
        "picoCodes": []
      }],
      "references": [],
      "files": []
    }]
  }],
  "references": []
};

export { MAGICfile1, MAGICfile2 };